import React, { useState, useEffect } from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import CodeIcon from '@mui/icons-material/Code';
import profileImage from '../assets/images/meghali-profile.jpg';
import '../assets/styles/Main.scss';

const roles = [
  "Software Development Engineer",
  "Full Stack Developer",
  "AI/ML Enthusiast"
];

function Main() {
  const [currentRole, setCurrentRole] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentRole((prevRole) => (prevRole + 1) % roles.length);
    }, 3000); // Change every 3 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={profileImage} alt="Meghali Dutta" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/Meghali54" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://linkedin.com/in/meghali-dutta" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
            <a href="https://leetcode.com/u/hackerslife/" target="_blank" rel="noreferrer"><CodeIcon/></a>
          </div>
          <h1>Meghali Dutta</h1>
          <p className="animated-role">{roles[currentRole]}</p>

          <div className="mobile_social_icons">
            <a href="https://github.com/Meghali54" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://linkedin.com/in/meghali-dutta" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
            <a href="https://leetcode.com/u/hackerslife/" target="_blank" rel="noreferrer"><CodeIcon/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;